import React from "react"
import Logo from "../../../assets/logo.png";
import moment from 'moment';
import { latest as API_URL } from "../../../config/api";
import { Form, Input, Tooltip, Icon, Cascader, Select, Row, Col, Checkbox, Button, AutoComplete,Layout, Menu, Breadcrumb, DatePicker,message } from 'antd';
import locale from 'antd/lib/date-picker/locale/es_ES';
import axios from "axios";
const postUrlLogin = API_URL + "jolie";
const { Header, Content, Footer } = Layout;

const FormItem = Form.Item;
const Option = Select.Option;
const AutoCompleteOption = AutoComplete.Option;
const residences = [{
    value: 'zhejiang',
    label: 'Zhejiang',
    children: [{
        value: 'hangzhou',
        label: 'Hangzhou',
        children: [{
            value: 'xihu',
            label: 'West Lake',
        }],
    }],
}, {
    value: 'jiangsu',
    label: 'Jiangsu',
    children: [{
        value: 'nanjing',
        label: 'Nanjing',
        children: [{
            value: 'zhonghuamen',
            label: 'Zhong Hua Men',
        }],
    }],
}];
const success = () => {
    message.success('Muchas gracias, hemos recibido tu registro correctamente, estaremos en contacto contigo muy pronto!', 5);
};

const successLoading = () => {
  message.loading('Espere un momento..')
};
class LayoutIndex extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            confirmDirty: false,
            autoCompleteResult: [], 
            active_slide : { key : "summary", index : 0 }, 
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
        }
    }
    
    getDefaultValues(){
        return {
            touch_values : {
                start : 0,
                end: 0
            },
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
        }
    }
    getResetValues(){
        return {
            active_slide : { key : "summary", index : 0 }, 
            slides : {
                0 : {
                    key: "summary", index: 0
                },
                1: {
                    key: "pickup", index: 1
                }
            },
            min_slide : 1,
            max_slide : 2, 
        }
    }

    handleSubmit = (e) => {
        e.preventDefault();
        this.props.form.validateFieldsAndScroll((err, values) => {
            if (!err) {
                let self = this;
                let qs = require("qs");
                const data_request = {
                    nombres: values.nombres,
                    apellidos: values.apellidos,
                    email: values.email,
                    datepicker: values.datepicker._d,
                    movil: values.movil,
                    api_token: localStorage.getItem("api_token"),
                }
                successLoading();
                axios({
                    method: "POST",
                    headers: {
                        'content-type': 'application/x-www-form-urlencoded'
                    },
                    url: postUrlLogin,
                    data: qs.stringify(data_request),
                }).then(function (response) {
                    message.destroy()
                    success();
                    self.props.form.setFieldsValue({
                        nombres: '',
                        apellidos: '',
                        email: '',
                        datepicker: '',
                        movil: ''
                    })
                    
                }).catch(error => {
                    console.log(error.response)
                    self.alertState('error_network')
                });
            }
        });
    }

    handleConfirmBlur = (e) => {
        const value = e.target.value;
        this.setState({
            confirmDirty: this.state.confirmDirty || !!value
        });
    }

    compareToFirstPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && value !== form.getFieldValue('password')) {
            callback('Two passwords that you enter is inconsistent!');
        } else {
            callback();
        }
    }

    validateToNextPassword = (rule, value, callback) => {
        const form = this.props.form;
        if (value && this.state.confirmDirty) {
            form.validateFields(['confirm'], {
                force: true
            });
        }
        callback();
    }

    handleWebsiteChange = (value) => {
        let autoCompleteResult;
        if (!value) {
            autoCompleteResult = [];
        } else {
            autoCompleteResult = ['.com', '.org', '.net'].map(domain => `${value}${domain}`);
        }
        this.setState({
            autoCompleteResult
        });
    }
    
    render() {
    const { getFieldDecorator } = this.props.form;
    const { autoCompleteResult } = this.state;

    const formItemLayout = {
      labelCol: {
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 16 },
      },
    };
    const tailFormItemLayout = {
      wrapperCol: {
        xs: {
          span: 24,
          offset: 0,
        },
        sm: {
          span: 16,
          offset: 8,
        },
      },
    };
    const prefixSelector = getFieldDecorator('prefix', {
      initialValue: '86',
    })(
      <Select style={{ width: 70 }}>
        <Option value="86">+86</Option>
        <Option value="87">+87</Option>
      </Select>
    );

    const websiteOptions = autoCompleteResult.map(website => (
      <AutoCompleteOption key={website}>{website}</AutoCompleteOption>
    ));
const config = {
      rules: [{ type: 'object', required: true, message: 'Campo obligatorio' }],
    };
    return (
        <Row>
      <Col span={12} offset={6}>
        <Layout className="layout">
            <div className='header-form'>
                <img src={Logo} />
            </div>
            <Content style={{ padding: '0 50px' }}>
                <div style={{ background: '#fff', padding: 24, minHeight: 280 }}>
                <Form onSubmit={this.handleSubmit}>
        <FormItem
          {...formItemLayout}
          label={(
            <span>
              Nombre(s)
            </span>
          )}
        >
          {getFieldDecorator('nombres', {
            rules: [{ required: true, message: 'Campo es obligatorio', whitespace: true }],
          })(
            <Input size='large'/>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label={(
            <span>
              Apellidos
            </span>
          )}
        >
          {getFieldDecorator('apellidos', {
            rules: [{ required: true, message: 'Campo es obligatorio', whitespace: true }],
          })(
            <Input  size='large'/>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="E-mail"
        >
          {getFieldDecorator('email', {
            rules: [{
              type: 'email', message: 'El email no es valido',
            }, {
              required: true, message: 'Campo obligatorio',
            }],
          })(
            <Input size='large'/>
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Móvil "
        >
          {getFieldDecorator('movil', {
            rules: [{ required: true, message: 'Campo obligatorio' }],
          })(
              <Input size='large' style={{ width: '100%' }} />
          )}
        </FormItem>
        <FormItem
          {...formItemLayout}
          label="Fecha de nacimiento"
        >
          {getFieldDecorator('datepicker', config)(
            <DatePicker size='large' style={{ width: '100%' }}  locale={locale} />
          )}
        </FormItem>
        <FormItem {...tailFormItemLayout}>
          <Button type="primary" htmlType="submit" size='large' style={{ width: '100%' }} >Enviar</Button>
        </FormItem>
      </Form>
                </div>
            </Content>
        </Layout></Col>
    </Row>
    );
  }
}


export default Form.create()(LayoutIndex)



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/review/Layout.js